import { ComponentInstall } from "../../utils";
import LinkMenu from "./src/LinkMenu";
import LinkMenuItem from "./src/LinkMenuItem";

export default ComponentInstall(LinkMenu, LinkMenuItem);
